import React from 'react';
import PropTypes from 'prop-types';

const FormattedEmailString = ({
  emailString,
  renderPartUsername,
  renderPartDomain,
  wrapperClasses = []
}) => {
  const hasAtCharacter = new RegExp('.*@.*');

  if (!hasAtCharacter.test(emailString)) {
    return <span className={wrapperClasses.join(' ')}>{emailString}</span>;
  }

  wrapperClasses.push('email-parts-wrap');

  return (
    <span className={wrapperClasses.join(' ')}>
      {!hasAtCharacter.test(emailString)
        ? emailString
        : emailString.split('@').map((namePart, index) => {
          const classNames = ['email-parts'];
          const isAccountName = index === 0;
          let content = namePart;

          classNames.push(isAccountName ? 'username' : 'domain');

          if (isAccountName && renderPartUsername) {
            content = renderPartUsername(namePart);
          }

          if (!isAccountName && renderPartDomain) {
            content = renderPartDomain(namePart);
          }

          return (
            <React.Fragment key={classNames.join('-')}>
              <span className={classNames.join(' ')}>{content}</span>
              {isAccountName ? '@' : null}
            </React.Fragment>
          );
        }
        )}
    </span>
  );
};

FormattedEmailString.propTypes = {
  emailString: PropTypes.string.isRequired,
  renderPartUsername: PropTypes.func,
  renderPartDomain: PropTypes.func,
  wrapperClasses: PropTypes.arrayOf(PropTypes.string)
};

export default FormattedEmailString;